import { Box } from '@mui/material';
import withStyles from '@mui/styles/withStyles';
import React from 'react';
import noUserPhoto from "../../images/no_photo_person.png";
import FileImage from '../FileImage';
import ErrorButton from '../FormControl/ErrorButton';
import { FileInputButton } from '../FormControl/FileInputButton';

interface UserPhotoInputProps {
    onChange: (file: File | null) => any;
    onError: (error: React.ReactNode) => any;
    error?: React.ReactNode;
    classes: Record<"userPhoto" | "userPhotoContainer" | "userPhotoContainerError", string>;
    value: File | Blob | null;
    src?: string | null;
    notShowRemove?: boolean;
}

interface UserPhotoInputState {
    
}

class UserPhotoInput extends React.Component<UserPhotoInputProps, UserPhotoInputState> {

    constructor(props: UserPhotoInputProps) {
        super(props);
        this.state = {
            
        };
        this.onFileChange = this.onFileChange.bind(this);
    }

    async componentDidMount() {
        
    }

    onFileChange(file: File) {
        const { onChange, onError } = this.props;
        if (file.type !== 'image/jpeg' && file.type !== 'image/png') {
            onError('A extensão da foto deve ser JPG ou PNG');
            return;
        }
        if (file.size > 5242880) {
            onError('A foto deve ter no máximo 5 MB');
            return;
        }
        onChange(file);
    }

    removeFile() {
        const { onChange } = this.props;
        onChange(null);
    }

    render() {
        const { error, classes, value, notShowRemove } = this.props;
        var containerClass = [classes.userPhotoContainer];
        if (error) {
            containerClass.push(classes.userPhotoContainerError);
        }
        return (
            <div>
                <Box display='flex' flexDirection="column">
                    <Box padding={1} alignSelf={'center'}>
                        <div className={containerClass.join(" ")}>
                            <FileImage file={value} src={this.props.src} noImageSrc={noUserPhoto} className={classes.userPhoto} />
                        </div>
                    </Box>
                    <Box padding={1} textAlign="center" alignSelf={'center'}>
                        <p style={{ margin: '5px 0', fontSize: '12px' }} key={`userPhoto-info-1`}>* A foto deve ter no máximo 5 MB</p>
                        <p style={{ margin: '0 0 5px 0', fontSize: '12px' }} key={`userPhoto-info-2`}>** A extensão da foto deve ser JPG ou PNG</p>
                        <FileInputButton
                            accept="image/*"
                            onFileChange={f => { this.onFileChange(f); }}
                            variant="contained"
                            color="primary"
                            size="small"
                            style={{
                                width: 150,
                                marginBottom: 5
                            }}
                        >
                            Selecione a foto
                        </FileInputButton>
                        {(value || this.props.src) && !notShowRemove ? <>
                            <br />
                            <ErrorButton
                                onClick={f => { this.removeFile(); }}
                                variant="contained"
                                style={{
                                    width: 150
                                }}
                                size="small"
                            >
                                Remover foto
                            </ErrorButton>
                        </> : null}
                    </Box>
                </Box>
                {error && <p style={{ margin: '5px 0', fontSize: '12px', color: 'red' }} key={`userPhoto-error`}>{error}</p>}
            </div>
        );
    }
}

export default withStyles((theme) => ({
    userPhoto: {
        width: 'auto',
        height: 'auto',
        maxWidth: 120,
        maxHeight: 140
    },
    userPhotoContainer: {
        boxShadow: '4px 2px 4px 1px rgba(0,0,0,0.2)',
        border: '1px solid #f2f2f2',
        borderRadius: 3,
        width: 120,
        height: 140,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
    },
    userPhotoContainerError: {
        border: '1px solid red',
    }
}), { name: 'UserPhotoInput' })(UserPhotoInput);